export default function Logo({ size = 40 }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 48 48"
            width={size}
            height={size}
            fill="none"
            aria-hidden="true"
        >
            <rect width="48" height="48" rx="12" fill="#3D5A45" />
            <path
                d="M14 16C14 13.7909 15.7909 12 18 12H32M23 12V36M14 24H28"
                stroke="#FAF7F2"
                strokeWidth="3.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <circle cx="32" cy="12" r="2.5" fill="#C85A32" />
        </svg>
    );
}
